import { defineMessages } from 'react-intl';

const messages = defineMessages({
  AddItem: {
    id: 'label_add_item',
    defaultMessage: 'Add item',
  },
  Contact: {
    id: 'label_contact',
    defaultMessage: 'Contact',
  },
  Function: {
    id: 'label_function',
    defaultMessage: 'Function',
  },
  DisplayName: {
    id: 'label_role_display_name',
    defaultMessage: 'Display name',
  },
  DisplayNameHelp: {
    id: 'help_role_display_name',
    defaultMessage: 'Overrides the title from the person page if needed.',
  },
  Description: {
    id: 'label_role_description',
    defaultMessage: 'Description',
  },
  DescriptionHelp: {
    id: 'help_role_description',
    defaultMessage: 'Shown in the frontend below the name.',
  },
  Link: {
    id: 'label_role_link',
    defaultMessage: 'Alternative Link',
  },
  LinkHelp: {
    id: 'help_role_link',
    defaultMessage: 'If empty, the click leads to the linked person page.',
  },
});

/**
 * Shared schema for "role" entries (a contact plus optional extra fields).
 * Used by multiple blocks (e.g. Contacts, Lecturers). Each block must declare
 * which fields it wants via the `fields` allowlist (no default), so a field only
 * appears in a block that explicitly lists it — no field leaks into a block that
 * did not opt in.
 */
const fieldDefinitions = (intl) => ({
  contact: {
    title: intl.formatMessage(messages.Contact),
    widgetOptions: {
      frontendOptions: {
        widget: 'object_browser',
        widgetProps: {
          mode: 'single',
          return: 'single',
          selectableTypes: ['Contact', 'TeamContact'],
        },
      },
    },
  },
  function: {
    title: intl.formatMessage(messages.Function),
    widgetOptions: {
      frontendOptions: {
        widget: 'select',
        widgetProps: {
          vocabulary: {
            '@id': '/@vocabularies/collective.taxonomy.function',
          },
        },
      },
    },
  },
  displayName: {
    title: intl.formatMessage(messages.DisplayName),
    description: intl.formatMessage(messages.DisplayNameHelp),
    widgetOptions: {
      frontendOptions: {
        widget: 'text',
      },
    },
  },
  description: {
    title: intl.formatMessage(messages.Description),
    description: intl.formatMessage(messages.DescriptionHelp),
    widgetOptions: {
      frontendOptions: {
        widget: 'text',
      },
    },
  },
  link: {
    title: intl.formatMessage(messages.Link),
    description: intl.formatMessage(messages.LinkHelp),
    widgetOptions: {
      frontendOptions: {
        widget: 'url',
      },
    },
  },
});

export const RoleSchema = ({ intl, fields }) => {
  const definitions = fieldDefinitions(intl);
  return {
    addMessage: intl.formatMessage(messages.AddItem),
    fieldsets: [
      {
        fields,
        id: 'default',
        title: '',
      },
    ],
    properties: Object.fromEntries(
      fields.map((key) => [key, definitions[key]]),
    ),
    required: [],
    title: intl.formatMessage(messages.Contact),
  };
};
